var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFridgeR(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 34,
    viewBox: "0 0 21 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.886 32.1556H3.12741C1.40321 32.1556 0 30.6942 0 28.8978V3.25843C0 1.46144 1.40321 0 3.12741 0H17.8855C19.6108 0 21.0134 1.46144 21.0134 3.25843V28.8978C21.0134 30.6942 19.6108 32.1556 17.886 32.1556ZM3.12741 2.05728C2.49187 2.05728 1.97509 2.59626 1.97509 3.25787V28.8972C1.97509 29.5594 2.4924 30.0984 3.12741 30.0984H17.8855C18.521 30.0984 19.0378 29.5594 19.0378 28.8978V3.25843C19.0378 2.59626 18.5205 2.05784 17.8855 2.05784L3.12741 2.05728Z",
    fill: "#EE4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 9.86106H3.95984C3.41417 9.86106 2.97229 9.40067 2.97229 8.83214C2.97229 8.26362 3.41471 7.80322 3.95984 7.80322H17.0542C17.5998 7.80322 18.0423 8.26362 18.0423 8.83214C18.0423 9.40067 17.5993 9.86106 17.0542 9.86106Z",
    fill: "#EE4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 14.8564H3.95984C3.41417 14.8564 2.97229 14.396 2.97229 13.8275C2.97229 13.259 3.41471 12.7986 3.95984 12.7986H17.0542C17.5998 12.7986 18.0423 13.259 18.0423 13.8275C18.0423 14.396 17.5993 14.8564 17.0542 14.8564Z",
    fill: "#EE4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 19.8728H3.95984C3.41417 19.8728 2.97229 19.4124 2.97229 18.8439C2.97229 18.2753 3.41471 17.8149 3.95984 17.8149H17.0542C17.5998 17.8149 18.0423 18.2753 18.0423 18.8439C18.0423 19.4124 17.5993 19.8728 17.0542 19.8728Z",
    fill: "#EE4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 24.8891H3.95984C3.41417 24.8891 2.97229 24.4287 2.97229 23.8602C2.97229 23.2917 3.41471 22.8313 3.95984 22.8313H17.0542C17.5998 22.8313 18.0423 23.2917 18.0423 23.8602C18.0423 24.4287 17.5993 24.8891 17.0542 24.8891Z",
    fill: "#EE4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13917 34H2.35017C2.23395 34 2.13983 33.5012 2.13983 32.8853C2.13983 32.2693 2.23406 31.7705 2.35017 31.7705H5.13917C5.25539 31.7705 5.34962 32.2693 5.34962 32.8853C5.34962 33.5012 5.25528 34 5.13917 34Z",
    fill: "#EE4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9783 34H15.1893C15.0731 34 14.979 33.5012 14.979 32.8853C14.979 32.2693 15.0732 31.7705 15.1893 31.7705H17.9783C18.0946 31.7705 18.1888 32.2693 18.1888 32.8853C18.1888 33.5012 18.0944 34 17.9783 34Z",
    fill: "#EE4142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8636,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridgeR);
export default __webpack_public_path__ + "static/media/fridgeR.f4458f906b0800fda5238f09a932bca1.svg";
export { ForwardRef as ReactComponent };